import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { interaction_arrows_chevronLeft, interaction_arrows_chevronRight } from '@lsg/icons';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject, cleanupClassNames } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { texts } from '../../utils/Localization.js';
import { fComp } from '../../utils/React.js';
import { IconLinkWrapper } from '../IconLink/IconLinkWrapper.js';
import '../IconLink/IconLinkPresentation.js';
import { hostClass } from './SliderPagination.styles.js';

var defaultProps = {
  onArrowRightClick: function onArrowRightClick() {
    /* empty */
  },
  onArrowLeftClick: function onArrowLeftClick() {
    /* empty */
  }
};
var SliderPaginationPresentation = fComp(function (props) {
  var _cleanupClassObject;

  var id = props.id,
      className = props.className,
      noMargin = props.noMargin,
      isStencilHost = props.isStencilHost,
      numDots = props.numDots,
      activeDotIndex = props.activeDotIndex,
      onArrowLeftClick = props.onArrowLeftClick,
      onArrowRightClick = props.onArrowRightClick,
      onPointClick = props.onPointClick;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass),
    id: id
  }, /*#__PURE__*/React.createElement(IconLinkWrapper, {
    noMargin: true,
    secondary: true,
    icon: interaction_arrows_chevronLeft,
    look: "no-text",
    onClick: onArrowLeftClick,
    className: cleanupClassNames(["".concat(hostClass, "-arrow"), "".concat(hostClass, "-arrow-left")]),
    disabled: activeDotIndex === 0
  }, texts.lsg.component.SliderPagination.previousPage), /*#__PURE__*/React.createElement("ul", {
    className: "".concat(hostClass, "-pointlist")
  }, Array.from(Array(numDots).keys()).map(function (i) {
    return /*#__PURE__*/React.createElement("li", {
      className: cleanupClassNames(["".concat(hostClass, "-point"), activeDotIndex === i && "".concat(hostClass, "-point-active")]),
      onClick: function onClick(e) {
        return onPointClick(i, e);
      },
      tabIndex: activeDotIndex === i ? 0 : -1,
      key: i
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(hostClass, "-point-dot")
    }));
  })), /*#__PURE__*/React.createElement(IconLinkWrapper, {
    noMargin: true,
    secondary: true,
    icon: interaction_arrows_chevronRight,
    look: "no-text",
    onClick: onArrowRightClick,
    className: cleanupClassNames(["".concat(hostClass, "-arrow"), "".concat(hostClass, "-arrow-right")]),
    disabled: activeDotIndex === numDots - 1
  }, texts.lsg.component.SliderPagination.nextPage)));
}, defaultProps);

export { SliderPaginationPresentation, defaultProps };
